<template>
	<div>
		<div class="title">
			<div class="blue"></div>
			<div style="flex: 1;">基本设置</div>
		</div>
		<el-button type="primary" style="margin-top: 5px;" size="small">新建服务</el-button>
		<el-table :cell-style="{'text-align':'center'}"
			:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable" :data="tableData"
			tooltip-effect="dark" style="width: 100%;margin-top: 15px;">
			<el-table-column prop="hairs" label="产品服务名称">
			</el-table-column>
			<el-table-column prop="title" label="服务描述">
			</el-table-column>
			<el-table-column prop="address" label="服务价格">
			</el-table-column>
			<el-table-column prop="storeType" label="创建日期">
				<template slot-scope="scope">
					{{ scope.row.storeType==0?"直营店":""}}
					{{ scope.row.storeType==1?"加盟店":""}}
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text">编辑</el-button>
					<el-button type="text">下架</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				tableData: [{
					date: '1231fcr34312412',
					name: '王小虎',
					phone: "18116651137",
					store: "五月花店",
					hairs: "tony",
					servise: "剪发",
					pay: 18,
					pingfen: "满意"
				}, {
					date: '1231fcr34312412',
					name: '王小虎',
					phone: "18116651137",
					store: "五月花店",
					hairs: "tony",
					servise: "剪发",
					pay: 18,
					pingfen: "满意"
				}, {
					date: '1231fcr34312412',
					name: '王小虎',
					phone: "18116651137",
					store: "五月花店",
					hairs: "tony",
					servise: "剪发",
					pay: 18,
					pingfen: "满意"
				}]

			}
		}
	}
</script>
<style lang="less" scoped>
	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}
</style>